import BuildingListComponent, {
  BuildingListComponentProps,
  testIds,
} from './BuildingListComponent';

export default BuildingListComponent;
export type { BuildingListComponentProps };
export { testIds };
